
import axios from './index'
import store from '@/store'
import { cleanParams } from '@/filters'
export const getTeamByPage = (params) => {
  const currentRole = store.state.currentRole
  const { companyId } = currentRole
  return axios.get('/welldbCombine/team', {
    params: cleanParams({ ...params, companyId, field: 'createTime', order: 'desc' })
  })
}

export const addTeam = (params) => {
  delete params.id
  return axios.post('/welldbCombine/team', {
    moveToQuery: true,
    params: { ...params }
  })
}

export const updateTeam = (params) => {
  return axios.put('/welldbCombine/team', {
    moveToQuery: true,
    params: params
  })
}

export const deleteTeam = (id) => {
  return axios.delete('/welldbCombine/team', {
    params: {
      id: id
    }
  })
}

export const getTeamMember = (params) => {
  return axios.get('/welldbCombine/teamMember', {
    params: { ...params, field: 'createTime', order: 'desc' }
  })
}
export const addTeamMember = (params) => {
  return axios.post('/welldbCombine/teamMember', {
    moveToQuery: true,
    params: params
  })
}

export const updateTeamMember = (params) => {
  return axios.put('/welldbCombine/teamMember', {
    moveToQuery: true,
    params: params
  })
}

export const deleteTeamMember = (id) => {
  return axios.delete('/welldbCombine/teamMember', {
    params: {
      id: id
    }
  })
}

// 修改成员账户
export const editTeamMember = (params) => {
  return axios.put('/welldbCombine/teamMember/edit', {
    ...params
  })
}

// 关联账号
export const binding = (params) => {
  return axios.post('/welldbCombine/teamMember/binding', {...params})
}


//删除成员账户
export const removeUser = (params) => {
  return axios.delete(`/welldbCombine/teamMember/remove`,{
    params
  })
}


